import {useTranslation} from 'react-i18next';
import {useValidatedState} from '../utils/ValidatedState';
import {Is} from '../utils/ValidationTools';
import {useSelector} from 'react-redux';
import {selectconfigtype} from '../selectors/config';
import {staticNumberFormatter} from '../utils/NumberFormatter';

export function usePhoneNumber(disable) {
  const {t} = useTranslation();
  return useValidatedState(
    '',
    [
      str => {
        if (str?.length === 0) {
          return {error: t('enter_phone_number')};
        }
      },
      str => {
        if (!Is.phoneNumber(str) || str.length !==11 ) {
          return {
            error: t('phone_number_validation'),
          };
        }
      },
    ],
    disable,
  );
}

export function useOtp(disable) {
  const {t} = useTranslation();
  return useValidatedState(
    '',
    [
      str => {
        if (str?.length === 0) {
          return {error: t('enter_otp_code')};
        }
      },
      str => {
        if (str?.length !== 6) {
          return {error: t('incorrecte_otp_code')};
        }
      },
    ],
    disable,
  );
}

export function useNationalCode(disable) {
  const {t} = useTranslation();
  return useValidatedState(
    '',
    [
      str => {
        if (str?.length === 0) {
          return {error: t('enter_national_code_error')};
        }
      },
      str => {
        if (!Is.nationalCode(str)) {
          return {
            error: t('national_code_validation'),
          };
        }
      },
    ],
    disable,
  );
}

export function useBirthDate(disable) {
  const {t} = useTranslation();
  return useValidatedState(
    '',
    [
      str => {
        if (str?.length === 0) {
          return {error: t('birth_date_is_require')};
        }
      },
    ],
    disable,
  );
}

export function useAuxiliary(disable) {
  const {t} = useTranslation();
  return useValidatedState(
    '',
    [
      str => {
        if (str?.length === 0) {
          return {error: t('enter_auxiliary_number')};
        }
      },
      str => {
        if (!Is.phoneNumber(str)) {
          return {
            error: t('auxiliary_validation'),
          };
        }
      },
    ],
    disable,
  );
}

export function useEmail(disable) {
  const {t} = useTranslation();
  return useValidatedState(
    '',
    [
      str => {
        if (str?.length === 0) {
          return {error: t('enter_email')};
        }
      },
      str => {
        if (!Is.email(str)) {
          return {
            error: t('email_validation'),
          };
        }
      },
    ],
    disable,
  );
}

export function useCharge(disable) {
  const {t} = useTranslation();
  const {minimum_increasing_amount} = useSelector(state =>
    selectconfigtype(state),
  );
  return useValidatedState(
    '',
    [
      str => {
        if (str?.length === 0) {
          return {error: t('enter_amount')};
        }
      },
      str => {
        if (Number(str) < Number(minimum_increasing_amount)) {
          return {
            error: `${t(
              'minimum_amount_credit_increase',
            )} ${staticNumberFormatter(minimum_increasing_amount)} ${t(
              'tomans',
            )}`,
          };
        }
      },
      str => {
        if (!Is.englishNumber(Number(str)) || Number(str) < 0  ) {
          return {
            error: t('price_is_not_valid'),
          };
        }
      },
    ],
    disable,
  );
}

export function useReturnDepositeMessage(disable) {
  const {t} = useTranslation();
  return useValidatedState(
    '',
    [
    ],
    disable,
  );
}

export function useRequestSuggestion(disable) {
  const {t} = useTranslation();
  return useValidatedState(
    '',
    [
      str => {
        if (str?.length === 0) {
          return {error: t('enter_message')};
        }
      },
      str => {
        if (str?.length < 50) {
          return {error:  t('message_shoudnt_be_less_than_50')};
        }
      },
    ],
    disable,
  );
}

export function  useReturnDeposite(disable) {
  const {t} = useTranslation();
  return useValidatedState(
    '',
    [
    ],
    disable,
  );
}

export function useRequestMessage(disable) {
  const {t} = useTranslation();
  return useValidatedState(
    '',
    [
      str => {
        if (str?.length === 0) {
          return {error: t('enter_message')};
        }
      },
    ],
    disable,
  );
}

export function useSheba(disable) {
  const {t} = useTranslation();
  return useValidatedState(
    '',
    [
      str => {
        if (str?.length === 2) {
          return {error: t('enter_sheba_number')};
        }
      },
      str => {
        if (!Is.validateIranianSheba(str)) {
          return {
            error: t('sheba_number_validation'),
          };
        }
        if (!Is.isNotBluBank(str)) {
          return {
            error: t('blu_bank_sheba'),
          };
        }
      },
    ],
    disable,
  );
}


export function useProfileSheba(disable) {
  const {t} = useTranslation();
  
  return useValidatedState(
    '',
    [
      str => {
        if (!Is.validateIranianSheba(str) && str!=='' && str!==' ') {
          return {
            error: t('sheba_number_validation'),
          };
        }
        if (!Is.isNotBluBank(str)) {
          return {
            error: t('blu_bank_sheba'),
          };
        }
      },
    ],
    disable,
  );
}
